import './Inbox.css';
/* src/Inbox.svelte generated by Svelte v3.23.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	outro_and_destroy_block,
	safe_not_equal,
	set_style,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "/web_modules/svelte/internal.js";

import EmailListItem from "./EmailListItem.js";
import Email from "./Email.js";

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[11] = list[i];
	return child_ctx;
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[14] = list[i];
	return child_ctx;
}

// (88:2) {#each mailboxes as mailbox}
function create_each_block_2(ctx) {
	let div;
	let t_value = /*mailbox*/ ctx[14] + "";
	let t;
	let div_data_name_value;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			t = text(t_value);
			attr(div, "data-name", div_data_name_value = /*mailbox*/ ctx[14]);
			attr(div, "class", "svelte-1drr5g5");
			toggle_class(div, "selectedMailboxLabel", /*activeMailbox*/ ctx[1] === /*mailbox*/ ctx[14]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);

			if (!mounted) {
				dispose = listen(div, "click", /*selectMbox*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*activeMailbox, mailboxes*/ 10) {
				toggle_class(div, "selectedMailboxLabel", /*activeMailbox*/ ctx[1] === /*mailbox*/ ctx[14]);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (100:2) {:else}
function create_else_block(ctx) {
	let button;
	let t1;
	let div;
	let current;
	let mounted;
	let dispose;
	let each_value_1 = /*data*/ ctx[0].threads.get(/*activeThreadId*/ ctx[2]).messages;
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			button = element("button");
			button.textContent = "Back";
			t1 = space();
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			set_style(div, "overflow", "scroll");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			insert(target, t1, anchor);
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[7]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*data, activeThreadId*/ 5) {
				each_value_1 = /*data*/ ctx[0].threads.get(/*activeThreadId*/ ctx[2]).messages;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div, null);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if (detaching) detach(t1);
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

// (96:35) 
function create_if_block_1(ctx) {
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_1_anchor;
	let current;
	let each_value = /*data*/ ctx[0].mailboxes[/*activeMailbox*/ ctx[1]];
	const get_key = ctx => /*threadId*/ ctx[8];

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*data, activeMailbox, activeThreadId*/ 7) {
				const each_value = /*data*/ ctx[0].mailboxes[/*activeMailbox*/ ctx[1]];
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, outro_and_destroy_block, create_each_block, each_1_anchor, get_each_context);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d(detaching);
			}

			if (detaching) detach(each_1_anchor);
		}
	};
}

// (94:2) {#if activeMailbox == null}
function create_if_block(ctx) {
	let t;

	return {
		c() {
			t = text("Select a mailbox from the list on the left");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (103:6) {#each data.threads.get(activeThreadId).messages as mid}
function create_each_block_1(ctx) {
	let current;

	const email = new Email({
			props: {
				raw: /*data*/ ctx[0].emailBytes.get(/*mid*/ ctx[11])
			}
		});

	return {
		c() {
			create_component(email.$$.fragment);
		},
		m(target, anchor) {
			mount_component(email, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const email_changes = {};
			if (dirty & /*data, activeThreadId*/ 5) email_changes.raw = /*data*/ ctx[0].emailBytes.get(/*mid*/ ctx[11]);
			email.$set(email_changes);
		},
		i(local) {
			if (current) return;
			transition_in(email.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(email.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(email, detaching);
		}
	};
}

// (97:4) {#each data.mailboxes[activeMailbox] as threadId (threadId)}
function create_each_block(key_1, ctx) {
	let first;
	let current;

	function func(...args) {
		return /*func*/ ctx[6](/*threadId*/ ctx[8], ...args);
	}

	const emaillistitem = new EmailListItem({
			props: {
				thread: /*data*/ ctx[0].threads.get(/*threadId*/ ctx[8]),
				onClick: func
			}
		});

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			create_component(emaillistitem.$$.fragment);
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			mount_component(emaillistitem, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const emaillistitem_changes = {};
			if (dirty & /*data, activeMailbox*/ 3) emaillistitem_changes.thread = /*data*/ ctx[0].threads.get(/*threadId*/ ctx[8]);
			if (dirty & /*activeThreadId, data, activeMailbox*/ 7) emaillistitem_changes.onClick = func;
			emaillistitem.$set(emaillistitem_changes);
		},
		i(local) {
			if (current) return;
			transition_in(emaillistitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(emaillistitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			destroy_component(emaillistitem, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div0;
	let t;
	let div1;
	let current_block_type_index;
	let if_block;
	let current;
	let each_value_2 = /*mailboxes*/ ctx[3];
	let each_blocks = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	const if_block_creators = [create_if_block, create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*activeMailbox*/ ctx[1] == null) return 0;
		if (/*activeThreadId*/ ctx[2] == null) return 1;
		return 2;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div0 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t = space();
			div1 = element("div");
			if_block.c();
			attr(div0, "id", "mailboxes");
			attr(div0, "class", "svelte-1drr5g5");
			attr(div1, "id", "content");
			attr(div1, "class", "svelte-1drr5g5");
		},
		m(target, anchor) {
			insert(target, div0, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div0, null);
			}

			insert(target, t, anchor);
			insert(target, div1, anchor);
			if_blocks[current_block_type_index].m(div1, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*mailboxes, activeMailbox, selectMbox*/ 26) {
				each_value_2 = /*mailboxes*/ ctx[3];
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_2(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div0, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_2.length;
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(div1, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div1);
			if_blocks[current_block_type_index].d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { data } = $$props;

	const sortOrder = {
		All: 1,
		Inbox: 2,
		Unread: 3,
		Sent: 4,
		Archived: 5,
		Spam: 6,
		"Has attachments": 10,
		"Category Promotions": 100,
		"Category Updates": 100,
		"Category Forums": 100,
		"Category Social": 100
	};

	let mailboxes = Object.keys(data.mailboxes).sort((a, b) => (sortOrder[a] || 50) - (sortOrder[b] || 50));
	let activeMailbox = mailboxes[0]; // string
	let activeThreadId = null; // string
	if (data.threads.size === 1) activeThreadId = data.threads.keys().next().value;

	function selectMbox(e) {
		$$invalidate(1, activeMailbox = e.target.dataset.name);
		$$invalidate(2, activeThreadId = null);
	}

	const func = threadId => {
		$$invalidate(2, activeThreadId = threadId);
	};

	const click_handler = () => {
		$$invalidate(2, activeThreadId = null);
	};

	$$self.$set = $$props => {
		if ("data" in $$props) $$invalidate(0, data = $$props.data);
	};

	return [
		data,
		activeMailbox,
		activeThreadId,
		mailboxes,
		selectMbox,
		sortOrder,
		func,
		click_handler
	];
}

class Inbox extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { data: 0 });
	}
}

export default Inbox;